import CardOpportunity from 'components/atoms/card_opportunity';
import OpportunityMapDashboard from 'components/molecules/opportunity_map_dashboard';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { totalOf } from 'hooks/useRepresentantDashboard';
import {
  OpportunityMetric,
  useRepresentantOpportunities,
} from 'hooks/useRepresentantOpportunities';
import { getSelectedRepresented } from 'services/selected_companies';
import { ApplicationState } from 'store';
import { BiddingState } from 'store/modules/bidding_store/types';
import { ImminenceState } from 'store/modules/get_dados_imminence_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import { Container } from './styles';

const OpportunitiesSession = () => {
  const { get_imminence } = useSelector<ApplicationState, ImminenceState>(
    (state) => state.session.get_imminence,
  );

  const { biddings, request } = useSelector<ApplicationState, BiddingState>(
    (state) => state.session.biddings,
  );

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const companies = useMemo(
    () => (profile.representant ? getSelectedRepresented(profile) : []),
    [profile],
  );
  const opportunities = useRepresentantOpportunities(companies);
  const multi = opportunities.enabled;
  const valueOf = (metric: OpportunityMetric, single: number) =>
    multi ? totalOf(opportunities.breakdown[metric]) : single;
  const multiProps = (metric: OpportunityMetric) =>
    multi ? { breakdown: opportunities.breakdown[metric], error: opportunities.error(metric) } : {};

  return (
    <Container>
      <h4 className="pt-3">Oportunidades</h4>
      <div className="row">
        <div className="col-md-6">
          <div className="d-md-flex px-md-0 px-3 h-100">
            <div className="card-container mr-md-3 mb-md-0 mb-3">
              <CardOpportunity
                title="Novas oportunidades do dia"
                background="bg-white"
                value={valueOf('hoje', biddings?.count_biddings_today)}
                url="/banco_de_dados"
                {...multiProps('hoje')}
              />
              <CardOpportunity
                title="Vigentes"
                background="bg-light"
                value={valueOf('vigentes', biddings?.count_biddings_future)}
                url="/banco_de_dados"
                {...multiProps('vigentes')}
              />
            </div>
            <div className="card-container ml-md-3 mb-md-0 mb-3">
              <CardOpportunity
                title="Iminência de deserta"
                background="bg-white"
                value={valueOf('iminencia', get_imminence?.total_imminence?.has_imminence)}
                url="/iminencia"
                shortcut="has_imminence"
                {...multiProps('iminencia')}
              />
              <CardOpportunity
                title="Baixa concorrência"
                background="bg-light"
                value={valueOf(
                  'baixa_concorrencia',
                  get_imminence?.total_imminence?.has_low_competition,
                )}
                url="/iminencia"
                shortcut="has_low_competition"
                {...multiProps('baixa_concorrencia')}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6 px-3">
          <OpportunityMapDashboard
            biddings_future_by_state={multi ? opportunities.states : biddings?.biddings_by_state}
            loading={multi ? opportunities.loading : request?.biddings_overview?.loading}
          />
        </div>
      </div>
    </Container>
  );
};

export default OpportunitiesSession;
